import Image from "next/image";

type PartnerLogo = {
  /** Path under /public, ideally a single-colour PNG or SVG. */
  src: string;
  /** The organization's name. */
  alt: string;
};

/**
 * Organizations that use inaraX. Empty until we have logos we are cleared to show, and the
 * section renders nothing while it is: a "trusted by" row of placeholders, or of atomcamp
 * (our own parent company), would read as a claim we cannot back. Adding a line here is the
 * whole switch-on.
 */
const logos: readonly PartnerLogo[] = [];

/**
 * Sits under the hero inside HeroCoverTransition, on the same colour as TheProblem, so the
 * two read as one panel sliding up over the pinned hero. Logos are knocked out to white
 * (brightness-0 invert) so mismatched brand colours sit evenly on the dark band.
 */
export default function TrustedBy() {
  if (logos.length === 0) return null;

  return (
    <section
      aria-labelledby="trusted-by-heading"
      className="bg-mkt-navbar px-margin-mobile md:px-margin-desktop pt-size-lg"
    >
      <div className="max-w-[1440px] mx-auto border-b border-white/10 pb-size-lg">
        <p
          id="trusted-by-heading"
          className="text-center font-label-md text-label-md uppercase tracking-widest text-white mb-size-md"
        >
          Trusted by organizations
        </p>
        <ul className="list-none pl-0 ml-0 flex flex-wrap items-center justify-center gap-x-size-xl gap-y-size-md">
          {logos.map((logo) => (
            <li key={logo.src} className="relative h-8 w-36 opacity-70 transition-opacity hover:opacity-100">
              <Image src={logo.src} alt={logo.alt} fill sizes="144px" className="object-contain brightness-0 invert" />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
